var _style, _path, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.4 101.1",
    style: {
      enableBackground: "new 0 0 144.4 101.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:url(#SVGID_2_);stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.25,
    y1: 50.5485,
    x2: 144.1496,
    y2: 50.5485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E52629"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83D3E"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 50.5485,
    x2: 144.3996,
    y2: 50.5485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD1B21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E73936"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.96,100.85c-5.11,0-10.22,0-15.33,0c-0.22-0.15-0.48-0.08-0.72-0.08c-8.31-0.15-16.62-0.3-24.93-0.69 c-3.85-0.18-7.69-0.39-11.53-0.68c-3.63-0.28-7.25-0.61-10.85-1.17c-1.66-0.26-3.3-0.58-4.85-1.26c-5.48-2.41-9.01-6.5-10.53-12.29 c-0.53-2.01-0.86-4.06-1.17-6.11c-0.49-3.2-0.83-6.42-1.09-9.65c-0.17-2.07-0.3-4.14-0.39-6.22c-0.19-4.29-0.35-8.57-0.31-12.86 c0.05-4.73,0.18-9.45,0.48-14.17c0.13-2.07,0.29-4.14,0.48-6.21c0.23-2.47,0.51-4.93,0.88-7.38c0.3-2,0.59-4,1.1-5.95 c1.05-4.01,3.27-7.26,6.57-9.77c1.9-1.44,4.01-2.52,6.34-3.03c2.88-0.64,5.82-0.97,8.76-1.28c2.35-0.25,4.71-0.44,7.06-0.62 c2.89-0.22,5.78-0.38,8.68-0.52c2.42-0.12,4.84-0.18,7.26-0.28c4.02-0.16,8.04-0.25,12.07-0.29c5.7-0.06,11.4-0.05,17.11-0.04 c6.12,0.01,12.24,0.13,18.36,0.31c4.35,0.12,8.69,0.29,13.03,0.52c2.08,0.11,4.15,0.22,6.22,0.37c2.47,0.18,4.94,0.36,7.4,0.66 c2.25,0.27,4.49,0.53,6.67,1.23c6.17,1.99,10.26,6.05,12.16,12.23c0.96,3.14,1.4,6.4,1.84,9.64c0.36,2.66,0.63,5.34,0.85,8.01 c0.24,3.02,0.44,6.05,0.5,9.08c0.07,3.47,0.1,6.93,0.07,10.4c-0.04,5.72-0.3,11.43-0.82,17.13c-0.4,4.33-0.95,8.63-1.75,12.91 c-0.38,2.07-0.91,4.09-1.92,5.95c-2.57,4.72-6.46,7.78-11.67,9.1c-1.99,0.51-4.04,0.75-6.08,1.01c-3.08,0.39-6.18,0.64-9.28,0.86 c-2.3,0.16-4.61,0.27-6.91,0.4c-3.58,0.2-7.16,0.32-10.75,0.42c-4.19,0.11-8.39,0.18-12.58,0.27 C82.25,100.76,82.08,100.69,81.96,100.85z M58.31,72.02c12.55-7.19,25.02-14.35,37.56-21.54c-12.55-7.2-25.03-14.35-37.56-21.54 C58.31,43.33,58.31,57.62,58.31,72.02z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5683e4302ca98af272d1f4fdfc71717c.svg";
export { ForwardRef as ReactComponent };